import React from 'react';

/**
 * AssistenteBotao (Deprecated)
 * Mantido apenas para evitar que imports antigos quebrem o build.
 * Agora o acesso ao assistente é feito pela Sidebar.
 */
const AssistenteBotao: React.FC = () => null;

export default AssistenteBotao;
